import PricelistProductSalesChannelTable from "@/features/pricelist-product-sales-channel/components/PricelistProductSalesChannelTable";
import {
	Button,
	FormBuilder,
  type FormBuilderSectionConfig,
	FormInfoError,
	cn,
} from "@k3-tech/react-kit";
import { useFormBuilder } from "@k3-tech/react-kit";
import type { PricelistProductEditFormData } from "../types/PricelistProductEditFormData";

export default function PricelistProductEditForm({
	initialData,
	onSubmit,
	onCancel,
}: {
	initialData: PricelistProductEditFormData;
	onSubmit: (data: PricelistProductEditFormData) => void;
	onCancel: () => void;
}) {
  const formSections: FormBuilderSectionConfig<PricelistProductEditFormData>[] = [
    {
      layout: "grid",
      grid: { cols: 1, mdCols: 2, gap: "gap-4" },
      fields: [
        {
          name: "pricelistProductID",
          label: "",
          type: "hidden",
        },
        {
          name: "productName",
          type: "text",
          label: "Product",
          disabled: true,
        },
        {
          name: "sellingPrice",
          type: "number",
          label: "Selling Price",
          required: true,
        },
      ],
    },
  ];
	const { form } = useFormBuilder<PricelistProductEditFormData>({
		defaultValues: initialData,
    sections: formSections,
	});

	return (
		<>
      <FormInfoError errors={form.formState.errors} className="mb-4" />
			<FormBuilder
				form={form as never}
				onSubmit={onSubmit}
				onCancel={onCancel}
				showActions={false}
				showActionsSeparator={false}
				actionsClassName="justify-end"
				sections={formSections}
				submitLabel="Save"
			/>
			<div className="mb-4">
				<div className="font-medium text-sm mb-4">Sales Channel</div>
				<PricelistProductSalesChannelTable
					pricelistProductID={initialData.pricelistProductID}
				/>
			</div>
			<div className={cn("flex flex-col sm:flex-row gap-3 justify-end")}>
				<Button
					type="submit"
					className="sm:order-last"
					onClick={form.handleSubmit(onSubmit)}
				>
					Save
				</Button>

				<Button type="button" variant="outline" onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</>
	);
}
